import Index = require("../index");

export interface IDocumentTemplateModel {
    name: string;
    documentTemplateId: number;
    documentType: Index.DocumentManagement.SolarDocumentType.SolarDocumentType;
    documentUploadModel: Index.DocumentManagement.CustomerDocumentUploadModel.IDocumentUploadModel;
}

export class DocumentTemplateModel implements IDocumentTemplateModel {
    name: string;
    documentTemplateId: number;
    documentType: Index.DocumentManagement.SolarDocumentType.SolarDocumentType;
    documentUploadModel: Index.DocumentManagement.CustomerDocumentUploadModel.IDocumentUploadModel;
}